







import { createComponent } from "@vue/composition-api";
import BaseNumericTag from "@web-components/components/BaseNumericTag.vue";

interface BaseDrinksOnDay {
  value: number;
  day: string;
}

export default createComponent({
  props: {
    value: {
      type: Number,
      required: true
    },
    day: {
      type: String,
      required: true
    }
  },
  components: {
    BaseNumericTag
  },
  setup(props: Readonly<BaseDrinksOnDay>, { emit }) {}
});
